import React, { type FC, useState, type ReactNode, useEffect } from 'react'
import classNames from 'classnames'
import { Badge, Icon, IconButton, Typography } from 'shared/ui'
import styles from './styles.module.scss'

type IAccordionSectionProps = {
  count?: number
  title?: string
  children: ReactNode
  renderButton?: ReactNode
  renderCustomHeader?: ReactNode
  show?: boolean
  fullWidthRight?: boolean
  hideChevronOnEmpty?: boolean
  showIconButton?: boolean
  headerStyles?: Record<string, string>
  callBackCollapse?: (status: boolean) => void
}

export const AccordionSection: FC<IAccordionSectionProps> = ({
  count,
  title,
  children,
  renderButton,
  renderCustomHeader,
  show,
  fullWidthRight,
  hideChevronOnEmpty = false,
  showIconButton,
  headerStyles,
  callBackCollapse,
}) => {
  const [open, setOpen] = useState(Boolean(show))
  const handleToggle = () => {
    callBackCollapse?.(!open)
    setOpen(!open)
  }

  const showLeftInfo = title || count
  const icon = open ? 'chevronUp' : 'chevronDown'
  const hasChildren = React.Children.toArray(children).filter(Boolean).length > 0
  const shouldShowChevron = hasChildren || !hideChevronOnEmpty

  useEffect(() => {
    if (show) setOpen(true)
  }, [show])

  return (
    <div>
      {renderCustomHeader && renderCustomHeader}
      {!renderCustomHeader && (
        <div className={styles.section} onClick={handleToggle} style={{ ...headerStyles }}>
          {showLeftInfo && (
            <div className={styles.box}>
              <Typography variant={'body-md-medium'} ariaLabel={'Title'} ellipsis>
                {title}
              </Typography>
              <Badge content={count} showAll ariaLabel={'Title_count'} />
            </div>
          )}
          <div className={classNames(styles.box, { [styles.fullWidth]: fullWidthRight })}>
            {renderButton}

            {shouldShowChevron &&
              (showIconButton ? (
                <IconButton
                  icon={icon}
                  active={open}
                  fontSize={16}
                  color={'secondary'}
                  variant={'contained'}
                  size={'small'}
                  ariaLabel={icon}
                />
              ) : (
                <Icon icon={icon} color={'var(--content-primary-tertiary)'} />
              ))}
          </div>
        </div>
      )}
      {open && children}
    </div>
  )
}
